import CasePreview from './CasePreview.js';
export default CasePreview;
//# sourceMappingURL=index.js.map